<template>
  <div class="unanswered-header flex-row">
    <span
      v-if="showPosition"
      class="flex-row"
    >
      <span class="icon-wrapper">
        <icon
          name="hash"
          variant="4B5565"
        ></icon>
      </span>
      <span>{{ sessionProgress }}</span>
    </span>
    <span
      v-if="flashcardMetadata"
      class="flex-row"
    >
      <span class="icon-wrapper">
        <icon
          name="bar-bell"
        ></icon>
      </span>
      <span>
        {{ flashcardMetadata.difficultyLabel }}
      </span>
    </span>
    <span class="spacer"></span>
    <button
      v-show="!isQotD && showPrevious"
      class="flex-row navigation"
      @click="$emit('previousFlashcard')"
    >
      <icon
        name="arrow-left-uui"
        variant="697586"
      ></icon>
      <span class="no-mobile">
        Prev
      </span>
    </button>
    <button
      v-show="!isQotD"
      class="flex-row navigation"
      @click="$emit('nextFlashcard')"
    >
      <span class="no-mobile">
        Next
      </span>
      <icon
        name="arrow-right-uui"
        variant="697586"
      ></icon>
    </button>
  </div>
</template>

<script>
import Icon from '@/components/singletons/icon';
import FlashcardMetadataMixin from '@/mixins/flashcardMetadata.js';

export default {
  components: { Icon },
  mixins: [FlashcardMetadataMixin],
  props: {
    category: {
      type: Object,
    },
    grouping: {
      type: Object,
    },
    flashcard: {
      type: Object,
      default: () => ({}),
    },
    isLearningPath: {
      type: Boolean,
      default: false,
    },
  },
  computed: {
    sessionProgress() {
      return `${this.currentPosition.position} of ${this.currentPosition.total}`;
    },
    isScenario() {
      return this.$route.name && this.$route.name.includes('scenario');
    },
    isQotD() {
      return this.$route.name && this.$route.name.includes('qotd');
    },
    currentPosition() {
      let position = 0;
      let total = 0;
      if (this.isLearningPath) {
        const learningPath = this.$store.getters['learningPath/flashcards'];
        total = learningPath.length;
        position = learningPath.findIndex(item => item.flashcardId === this.flashcard.id) + 1;
      } else if (this.category && this.$store.getters['categoryTypes/quizCategoryTypes'].map(ct => ct.id).includes(this.category.categoryTypeId)) {
        total = this.category.counts.total;
        position = (total - this.currentSession.length) + this.currentSession.indexOf(this.flashcard.id) + 1;
      } else if (this.grouping) {
        total = this.grouping.assetAssociations.length;
        position = this.grouping.sortedAssetAssociations.findIndex(aa => aa.assetBId === this.flashcard.id) + 1;
      } else if (this.isScenario) {
        total = this.category?.counts.total;
        position = (total - this.currentSession.length) + this.currentSession.indexOf(this.flashcard.id) + 1;
      } else {
        position = this.currentSession.indexOf(this.flashcard.id) + 1;
        total = this.currentSession.length;
      }

      return {
        position: position,
        total: total,
      };
    },
    currentSession() {
      return this.$store.getters['flashcards/currentSession'];
    },
    showPosition() {
      if (this.isQotD) return false;
      return this.currentPosition.total > 0 && this.currentPosition.position > 0;
    },
    showPrevious() {
      return this.currentPosition.position > 1;
    },
  },
};
</script>

<style lang="scss" scoped>
.flex-row {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: .25rem;
}
.unanswered-header {
  margin: 1rem;
  gap: 1rem;
  line-height: rem-calc(20);
  font-size: rem-calc(14);
  font-weight: 600;
  color: #697586;

  .spacer {
    flex-grow: 1;
  }
  .navigation {
    background-color: transparent;
    padding: 0;
    color: #697586;
  }

  .icon-wrapper {
    background-color: #EEF2F6;
    border-radius: rem-calc(4);
    height: rem-calc(24);
    width: rem-calc(24);
    display: grid;
    place-items: center;
  }
}

.no-mobile {
  display: none;
}

@include breakpoint(tablet) {
  .no-mobile {
    display: inline;
  }
}

@include breakpoint(desktop) {
  .no-mobile {
    display: inline;
  }
  .unanswered-header {
    margin: 2rem;
  }
}

</style>
